const fileDownload = (file) => {
  const blob = new Blob([file], {
    type: "application/vnd.ms-excel;charset=utf-8",
  });
  var date =
    "file_" +
    new Date().getFullYear() +
    "" +
    (new Date().getMonth() + 1) +
    "" +
    new Date().getDate();
  const fileName = date + ".xlsx";
  if ("download" in document.createElement("a")) {
    //Non ie Download
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // release the URL object
    document.body.removeChild(elink);
  } else {
    //Ie10 + download
    navigator.msSaveBlob(blob, fileName);
  }
};

const fileDownloadPDF = (file, name) => {
  const blob = new Blob([file], {
    type: "application/pdf",
  });
  const fileName = name + ".pdf";
  if ("download" in document.createElement("a")) {
    //Non ie Download
    const elink = document.createElement("a");
    elink.download = fileName;
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // release the URL object
    document.body.removeChild(elink);
  } else {
    //Ie10 + download
    navigator.msSaveBlob(blob, fileName);
  }
};

export { fileDownload, fileDownloadPDF };
